alignDirectiveModule = angular.module('valign.setting', [])

alignDirectiveModule.directive "valigmentSetting", ["$window", "$timeout", "$compile", "$templateCache", ($window, $timeout, $compile, $templateCache) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/valignment/template.jade"
  link: (scope, element, attrs, ngModel) ->
    if !scope.data
      scope.data = "middle"
    scope.verticalAlign = scope.data

    listener = scope.$watch "verticalAlign", (newVal) ->
      scope.data = newVal

    scope.$on "$destroy", ->
      listener()
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/valignment/valign.directive.coffee